export enum UserPermissions {
  readProjects = 'read-projects',
  createProjects = 'create-projects',
  updateProjects = 'update-projects',
  deleteProjects = 'delete-projects',

  readClients = 'read-clients',
  createClients = 'create-clients',
  updateClients = 'update-clients',
  deleteClients = 'delete-clients'
}
